import { Box } from '@wix/design-system';
import {
  Faq,
  HeaderBanner,
  useAnonymous,
} from '@wix/package-picker-shared-studio';
import { NavigationButton } from '@wix/premium-purchase-platform/@ui';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { Header } from '../Header/Header';
import { PageFooter } from '../PageFooter/PageFooter';
import s from './PageLayout.scss';

type PageLayoutProps = {
  children: React.ReactNode;
} & (
  | { onBack: () => void; backButtonText: string }
  | { onBack?: never; backButtonText?: never }
);

export const PageLayout = ({
  children,
  onBack,
  backButtonText,
}: PageLayoutProps) => {
  const { t, Trans } = StudioPackagePickerModule.internals.useTranslations();
  const { isAnonymous } = useAnonymous();

  return (
    <Box
      direction="vertical"
      width="100%"
      align="center"
      marginBottom={isAnonymous ? '' : 'SP5'}
    >
      <Box width="100%" marginBottom="SP2">
        {!isAnonymous && <HeaderBanner shouldShowSwitchPlanBanner />}
      </Box>
      <Box>
        {onBack && (
          <NavigationButton
            onClick={onBack}
            text={backButtonText}
            direction="back"
            className={s.backButton}
            isVisible={true}
          />
        )}
        <Header />
      </Box>
      <Box
        width="100%"
        align="center"
        direction="vertical"
        maxWidth="1140px"
        marginBottom="SP7"
      >
        {children}
      </Box>
      <Faq t={t} Trans={Trans} />
      <PageFooter />
    </Box>
  );
};
